import { Security } from 'actions';

const initialState = {
  isFetching: false,
  security: null,
  search: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Security.SECURITY_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case Security.SECURITY_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        security: action.data,
      };
    case Security.SECURITY_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        search: action.data,
      };
    case Security.SECURITY_CLEAR:
    case Security.SECURITY_FAIL:
      return initialState;
    default:
      return state;
  }
}
